import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import ChangePasswordCard from "./ChangePasswordCard";

const FIELDS = [
  { k:"company_name", l:"Company name" },
  { k:"tagline", l:"Tagline", full:true },
  { k:"contact_email", l:"Contact email" },
  { k:"contact_phone", l:"Contact phone" },
  { k:"whatsapp_number", l:"WhatsApp number" },
  { k:"address", l:"Address", full:true },
  { k:"instagram_url", l:"Instagram URL", full:true },
  { k:"default_interest_rate", l:"Default interest rate (%)", n:true },
];

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(({data}) => setS(data)); }, []);
  const save = async () => {
    try { const { id, ...body } = s; await api.put("/settings", body); toast.success("Settings saved"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  if (!s) return <div className="p-16 text-center text-black/40">Loading...</div>;
  return (
    <div className="p-8 lg:p-12 max-w-3xl" data-testid="admin-settings">
      <h1 className="font-display text-3xl">Settings</h1>
      <p className="text-black/50 mt-1">Company details shown on your website & receipts.</p>
      <div className="grid grid-cols-2 gap-5 mt-8 bg-white border border-[#EAEAEA] rounded-xl p-8">
        {FIELDS.map(f => (
          <label key={f.k} className={`block ${f.full?"col-span-2":""}`}>
            <div className="text-xs uppercase tracking-widest text-black/50 mb-1">{f.l}</div>
            <input data-testid={`setting-${f.k}`} type={f.n?"number":"text"} step={f.n?"0.1":undefined} className="w-full border border-[#EAEAEA] rounded-lg px-3 py-2 focus:border-[#D4AF37] outline-none"
              value={s[f.k]||""} onChange={(e)=>setS({...s,[f.k]:f.n?+e.target.value:e.target.value})}/>
          </label>
        ))}
        <div className="col-span-2 flex justify-end">
          <button data-testid="settings-save" onClick={save} className="sk-btn-gold">Save changes</button>
        </div>
      </div>
      <ChangePasswordCard/>
    </div>
  );
}
